import { render, staticRenderFns } from "./TemplateAdmin.vue?vue&type=template&id=0686785d"
import script from "./TemplateAdmin.vue?vue&type=script&lang=js"
export * from "./TemplateAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports